export default __webpack_public_path__ + "static/media/6.f02cc447.jpg";